import clsx from 'clsx';
import { CtaBtn } from '../CtaBtn';
import styles from './MainSection.module.css';

export function MainSection({
  title,
  subTitle,
  imgSrc,
  imgSrcMobile,
  mainText,
  ctaLink,
  ctaText,
}) {
  return (
    <section className="w-full max-w-screen-xl mx-auto">
      <div
        className={clsx(
          'w-full flex flex-col items-center mt-[30px]',
          'lg:flex lg:flex-row lg:justify-between lg:items-center',
        )}
      >
        <div className="flex flex-col justify-center items-center min-[1024px]:block">
          {/* The radiance effect */}
          <div className={styles.radiance} />

          <h1 className="mb-2 text-base md:text-xl font-extrabold text-start md:!m-0 lg:text-[60px] 2xl:text-[70px]">
            {title}
          </h1>
          <h2 className="text-base md:text-xl md:my-6 !mb-0 font-extrabold text-start lg:text-[30px] mt-[12px]">
            {subTitle}
          </h2>

          <div className="shadow-darkRed h-full max-w-60 md:max-w-80 md:h-100 relative overflow-hidden rounded-[16px] !my-2 md:!mb-0 lg:hidden mt-[8px]">
            <img
              width={100}
              height={100}
              src={imgSrcMobile}
              alt="Beautiful AI girl"
              className={clsx(
                'lg:hidden',
                'w-full',
                'px-[5px]',
                'rounded-[12px]',
              )}
            />
          </div>
          <p className="text-center w-70 my-5 mx-4 text-[16px] lg:w-auto md:mx-0 text-wtf-white lg:text-start">
            {mainText}
          </p>

          <div
            className={clsx(
              'w-full lg:mx-0',
              'lg:mt-10',
              'flex flex-row justify-center px-8 lg:px-0 lg:justify-start',
            )}
          >
            <CtaBtn
              href={ctaLink}
              text={ctaText}
              className="md:max-w-[230px]"
            />
          </div>
        </div>

        <div
          className={clsx(
            'w-full max-w-[500px] ml-5 h-[700px]',
            'mt-14',
            'hidden lg:!flex lg:!flex-row lg:!justify-center lg:!items-center',
          )}
        >
          <div
            className={clsx(
              'flex-[1] basis-1/3',
              'max-w-[428px]',
              'hidden lg:!flex lg:!flex-row lg:!justify-center lg:!items-center',
            )}
          >
            <img
              src={imgSrc}
              alt="Beautiful AI girl"
              width={428}
              height={428}
              className="rounded-[12px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
